//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../Mechatronics/Mechatronics.WebNodeListItemBuilderList.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/ObjectList.js";
let d=[[[0,"AsWebBranch",1,0],[1,"CenterPlane",0,"SelectNXObject",1],[0,"CenterReferencePlane",1,"Plane",0],[0,"Color",1,0],[0,"ColorOption",1,0],[0,"Name",1,0],[1,"NodeList",0,"Mechatronics.WebNodeListItemBuilderList",0],[0,"Translucency",1,0],[0,"UseConvergentBody",1,0],[1,"WebThickness",0,"Expression",0],[1,"WebWidth",0,"Expression",0]],[[["datumPlane"],"ConvertDatumPlane",{},1,0],[["nodeListItemBuilder","updateType"],"UpdatePreviewedBody",{},2,1],[[],"UpdatePreviewedBodies",{},0,0],[["nodeListItemBuilder"],"CycleSolution",{},1,0],[[],"ReverseAllSolutions",{},0,0],[["nodeListItemBuilders"],"GroupNodes",{},1,0],[["nodeListItemBuilders"],"UngroupNodes",{},1,0],[["nodeListItemBuilder","bodyType"],"DeletePreviewedBody",{},2,1],[[],"DeletePreviewedBodies",{},0,0],[["nodeListItemBuilder"],"DeleteNodePreviewedBody",{},1,0],[[],"ConvertPreviewedBodies",{},0,0],[[],"UpdateWebDisplay",{},0,0]],[]];
SPLM.Mechatronics.WebBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.WebBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.WebBuilder.NodeListUpdateTypes = Object.freeze({
    "Edit" : "Edit", "MoveUp" : "MoveUp", "MoveDown" : "MoveDown"});

SPLM.Mechatronics.WebBuilder.PreviewedBodyTypes = Object.freeze({
    "WindingBody" : "WindingBody", "ConnectionBody" : "ConnectionBody", "All" : "All"});

SPLM.Mechatronics.WebBuilder.ColorOptions = Object.freeze({
    "SpecifyColor" : "SpecifyColor", "NoColor" : "NoColor"});

export default SPLM;